import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../components/Button/Button";
import { useHistory } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { LoadingState } from "../../stores/LoadingState";
import { ErrorLabel } from "../../components/ErrorLabel";
import { RoutePath } from "../Router";
import { ColumnPage } from "../../components/ColumnPage";

export const Email = observer(() => {
  const { t } = useTranslation("mobile");
  const { authenticationStore, analyticsStore } = useStores();
  const history = useHistory();
  const [error, setError] = useState("");
  const [input, setInput] = useState("");
  const [autoSubmit, setAutoSubmit] = useState(false);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const urlParameters = new URLSearchParams(window.location.search);
    const emailParameter: string | null = urlParameters.get("email");
    if (emailParameter) {
      setInput(emailParameter);
      setAutoSubmit(true);
    }
    analyticsStore.authenticationStarted();
  }, []);

  useEffect(() => {
    if (autoSubmit) {
      buttonRef?.current?.click();
    }
  }, [autoSubmit]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await authenticationStore.requestEmailVerification(input);
      history.push(RoutePath.codeConfirmation);
    } catch (e: any) {
      console.error(error);
      setError(e.message);
    }
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput(event.target.value);
  };

  return (
    <ColumnPage>
      <form data-test-id="emailForm" onSubmit={onSubmit}>
        <label
          data-test-id="emailInstructionDiv"
          className="u-color-neutral-darker"
          htmlFor="emailInput"
        >
          {t("email.instruction")}
        </label>
        <div className="u-margin-top-gutter">
          {error !== "" && (
            <ErrorLabel message={error} className={"u-margin-bottom-gutter"} />
          )}
          <input
            data-test-id="emailInput"
            value={input}
            onChange={onChange}
            type="email"
            required={true}
            className={"c-input " + (error ? "is-invalid" : "")}
            placeholder={t("email.placeholder")}
          />
        </div>
        <div className="u-margin-top-gutter">
          <Button
            ref={buttonRef}
            type="submit"
            isLoading={
              authenticationStore.loadingState === LoadingState.Loading
            }
            testId="emailSubmit"
          >
            {t("common.verify")}
          </Button>
        </div>
      </form>
    </ColumnPage>
  );
});
